import ProjectsComponent from '@/components/projects/projects.component';
import { MyPage } from '@/types/my-page.type';

const Projects: MyPage = () => {
  return <ProjectsComponent />;
};
export default Projects;
Projects.layout = 'Dashboard';
